import { useCallback, useState } from 'react'

export function useAnnounce() {
  const [message, setMessage] = useState('')

  const announce = useCallback((msg: string) => {
    setMessage('')
    setTimeout(() => {
      setMessage(msg)
    }, 50)
  }, [])

  return { message, announce }
}
